import useKeelLogoSwitch from "../../hooks/useKeelLogoSwitch";
import HamburgerDropdown from "../HamburgerDropdown/HamburgerDropdown";
import styles from "./HamburgerMenu.module.css";
import MindPageLink from "../MindPageLink/MindPageLink";
import { Link } from "react-router-dom";
import { megaMenu } from "../../data/navigation";
import MegaMenuCard from "../MegaMenuCard/MegaMenuCard";

function HamburgerMenu({
    className,
    showMenu,
    setShowMenu,
    menuRef,
    showSignIn,
}) {
    const { logoSrc, logoHref } = useKeelLogoSwitch(false, true);

    function handleCloseClick() {
        // props.menuRef.current.classList.toggle("show");
        setShowMenu(false);
    }

    function handleEscape(event) {
        if (event.keyCode === 27) {
            setShowMenu(false);
        }
    }

    return (
        <div
            // style={{ display: "none" }}
            ref={menuRef}
            style={
                {
                    // visibility: "hidden",
                }
            }
            className={[
                styles.hamburger_menu_wrapper,
                showMenu ? styles.show : "",
                className,
            ].join(" ")}
            onKeyDown={handleEscape}
        >
            <div className={styles.cover} onClick={handleCloseClick}></div>
            <div className={styles.menu_scroll_wrapper}>
                <div className={styles.menu}>
                    <div className={styles.menu_header}>
                        <MindPageLink href={logoHref}>
                            <img
                                draggable={false}
                                id={styles.logo}
                                src={logoSrc}
                                alt={"Keel Digital Solutions logo"}
                            />
                        </MindPageLink>
                        <button
                            onClick={handleCloseClick}
                            className={styles.close_button}
                            aria-label="Close navigation menu"
                        >
                            <img
                                src="/images/modal-close-icon-thick-white.svg"
                                alt="Close navigation menu"
                            />
                        </button>
                    </div>
                    <div id={styles.links_container}>
                        {megaMenu.map((obj) => (
                            <HamburgerDropdown
                                text={obj.navName}
                                className={styles.link}
                                key={obj.navName}
                                menuState={showMenu}
                            >
                                {obj.children.map((link) => (
                                    <MegaMenuCard
                                        key={link.name}
                                        {...link}
                                        setShowMenu={setShowMenu}
                                    />
                                ))}
                            </HamburgerDropdown>
                        ))}
                        <div id={styles.bottom_links}>
                            {showSignIn && (
                                <HamburgerDropdown
                                    text={"Sign in"}
                                    className={styles.link}
                                    menuState={showMenu}
                                >
                                    <Link
                                        target="_blank"
                                        to={
                                            "https://app.us.geta-head.com/app/gah/"
                                        }
                                        className={styles.dropdown_link}
                                    >
                                        United States
                                    </Link>
                                    <Link
                                        target="_blank"
                                        to={
                                            "https://app.ca.geta-head.com/app/gah/"
                                        }
                                        className={styles.dropdown_link}
                                    >
                                        Canada
                                    </Link>
                                </HamburgerDropdown>
                            )}
                            <Link
                                to={"/contact-us"}
                                id={styles.contact_us_link}
                                className={[
                                    styles.link /*, "orange-button"*/,
                                ].join(" ")}
                            >
                                Contact us
                                <img
                                    id={styles.contact_us_arrow}
                                    src="/images/large-arrow-up-right.svg"
                                    alt=""
                                />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HamburgerMenu;
